module.exports = __webpack_public_path__ + "img/plan4_book08.0294b070.png";